module.exports = __webpack_public_path__ + "dimer/static/img/15.9aaeeee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/15.jpg
// module id = rkeO
// module chunks = 0